/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why convert RPM to RCF?`)
};

const es_gf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué convertir RPM a RCF?`)
};

const de_gf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum RPM in RCF umrechnen?`)
};

const nl_gf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom RPM naar RCF omrekenen?`)
};

const fr_gf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi convertir les RPM en RCF ?`)
};

const it_gf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché convertire gli RPM in RCF?`)
};

const pt_br2_gf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que converter RPM em RCF?`)
};

const pt_gf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porquê converter RPM em RCF?`)
};

const ja_gf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜRPMをRCFに変換するのですか?`)
};

const zh_gf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么要把 RPM 换算成 RCF？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_faq_q2", locale)
	if (locale === "en") return en_gf_faq_q2(inputs)
	if (locale === "es") return es_gf_faq_q2(inputs)
	if (locale === "de") return de_gf_faq_q2(inputs)
	if (locale === "nl") return nl_gf_faq_q2(inputs)
	if (locale === "fr") return fr_gf_faq_q2(inputs)
	if (locale === "it") return it_gf_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_gf_faq_q2(inputs)
	if (locale === "pt") return pt_gf_faq_q2(inputs)
	if (locale === "ja") return ja_gf_faq_q2(inputs)
	return zh_gf_faq_q2(inputs)
};